import { render, staticRenderFns } from "./AdminLogin.vue?vue&type=template&id=3bd871bc&scoped=true&"
import script from "./AdminLogin.vue?vue&type=script&lang=js&"
export * from "./AdminLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd871bc",
  null
  
)

export default component.exports